import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

/**
 * JournalPreview — the right-column card on the Dashboard's "Glow Up Today" section.
 * Rotating prompt by day of week, ghost CTA into /reflections.
 */
const DAILY_PROMPTS = {
  1: 'New week. Fresh start. Let\'s talk about it, sis!',           // Monday
  2: 'This is a safe space, sis. What\'s really on your mind?',     // Tuesday
  3: 'Halfway through. What\'s feeling heavy right now?',           // Wednesday
  4: 'What\'s one thing you\'re proud of yourself for this week?',  // Thursday
  5: 'Before you close out the week — what do you want to release?',// Friday
  6: 'Rest day check-in. How are you really feeling?',              // Saturday
  0: 'New week is coming. What intention are you setting?',         // Sunday
};

const formatToday = (d) =>
  d.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' });

export default function JournalPreview() {
  const today = new Date();
  const prompt = DAILY_PROMPTS[today.getDay()];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.55 }}
      className="rounded-2xl p-5 sm:p-6 h-full flex flex-col lg:justify-center"
      style={{
        backgroundColor: '#F0EBE3',
        borderLeft: '3px solid #B8956A',
      }}
      data-testid="journal-preview"
    >
      {/* Small gold label */}
      <p
        className="text-[10px] uppercase tracking-[0.12em] font-semibold mb-2"
        style={{ color: '#B8956A' }}
      >
        Daily Reflection
      </p>

      {/* Date */}
      <p className="text-xs text-[#AA9283] mb-4" data-testid="journal-today-date">
        {formatToday(today)}
      </p>

      {/* Rotating prompt */}
      <p
        className="text-[13px] italic leading-relaxed mb-5"
        style={{ color: '#3D3229' }}
        data-testid="journal-prompt"
      >
        "{prompt}"
      </p>

      {/* Motivational line — intentional spacing on desktop */}
      <p
        className="text-[12px] italic text-center text-[#AA9283] mb-5"
        data-testid="journal-motivation-line"
      >
        Your journal is private. Just you and your thoughts, sis.
      </p>

      {/* Divider */}
      <div
        className="h-px w-full mb-4"
        style={{ backgroundColor: '#e8e4dc' }}
      />

      {/* Ghost CTA */}
      <Link to="/reflections" className="block" data-testid="journal-open-cta">
        <button
          type="button"
          className="w-full py-2.5 rounded-full text-sm font-medium transition-all hover:bg-[#B8956A]/10 inline-flex items-center justify-center gap-2"
          style={{
            border: '1.5px solid #B8956A',
            color: '#B8956A',
            backgroundColor: 'transparent',
          }}
        >
          Open My Journal
          <ArrowRight className="h-4 w-4" />
        </button>
      </Link>

      {/* Fine print */}
      <p className="text-[11px] text-[#AA9283] text-center mt-3">
        Daily check-in + weekly reflection inside
      </p>
    </motion.div>
  );
}
